export const SIGNATURE_REDUCER_NAME = 'signature';
